import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { CvDataProvider } from './context/CvDataContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CvDataProvider>
      <App />
    </CvDataProvider>
  </React.StrictMode>
);
